import { installedItems } from "@p0security/shared/install/installed";
import { awsPartitionFromUse } from "@p0security/shared/integrations/resources/aws/gov-cloud";
import { existingIamWriteAndAssessmentItems } from "@p0security/shared/integrations/resources/aws/install-options";
import {
  accessLogsInstallCommands,
  accessLogsTerraform,
} from "@p0security/shared/integrations/resources/aws/policy/access-logs";
import Link from "antd/lib/typography/Link";

import { AwsInstaller } from "../types";

const accessLogsInstructions: AwsInstaller["access-logs"]["instructions"] = (
  context,
  id
) => {
  const awsPartition = awsPartitionFromUse(context.config, id, "access-logs");
  return {
    help: (
      <>
        To install P0 on this account, provision P0&apos;s access using{" "}
        <Link
          href={`https://${id}.signin.aws.amazon.com/console`}
          target="_blank"
          rel="noopener"
        >
          AWS Cloud Shell
        </Link>{" "}
        or Terraform:
      </>
    ),
    commands: {
      shell: [
        {
          command: accessLogsInstallCommands(
            context,
            {
              restrictResourceToARNs: [
                context.config["access-logs"][id]?.cloudLakeArn,
              ],
            },
            {
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              awsAccountId: id,
              awsPartition,
            }
          ),
        },
      ],
      iac: [
        {
          command: accessLogsTerraform(
            context,
            {},
            context.config.base[id]?.serviceAccountId,
            awsPartition
          ),
        },
      ],
    },
  };
};

export const awsAccessLogsInstaller: AwsInstaller["access-logs"] = {
  instructions: accessLogsInstructions,
  optionProvider: async ({ config }) => {
    const existingAccessLogs = installedItems("access-logs", config);
    return existingIamWriteAndAssessmentItems(config)
      .filter(([id]) => !(id in existingAccessLogs))
      .map(([id, item]) => ({
        id,
        label: item?.label,
      }));
  },
  items: {
    cloudLakeArn: {},
  },
};
